export enum PaymentMethod {
  ACH = 'ach',
  ApplePay = 'apple-pay',
  CreditCard = 'credit-card',
  Financing = 'financing',
  GooglePay = 'google-pay',
  MonthlyRental = 'monthly-rental',
  PayByBank = 'pay-by-bank',
  PayPal = 'pay-pal',
  PersonalCheck = 'personal-check',
  RentToOwn = 'rent-to-own',
}
